import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataCreate = parseToMutationRequest(data, [
    'type',
    'index',
    'locationIndex',
    'autoCreateLegalEntities',
    'autoCreateBusinessUnits',
  ]);
  const createEnterprise = `createEnterprise(input: ${dataCreate})`;
  return gql`
  mutation {
    ${createEnterprise} {
      id
    }
  }
`;
};
